import {
  IconFileText,
  IconFileTypePdf,
  IconCertificate,
  IconVideo,
  IconPlayerPlay,
  IconDownload,
} from "@tabler/icons-react";
import styles from "../../../../pages/TalentDashboard/Profile/profile.module.css";
import Reveal from "../../../Reveal/Reveal";
import Button from "../../../UI/Button/button";

export default function MediaTab({ data, resetKey }) {
  return (
    <div className={styles.stack}>
      <Reveal index={0} resetKey={resetKey}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardHeaderLeft}>
              <div className={styles.cardIcon}>
                <IconFileText size={18} />
              </div>
              <div>
                <div className={styles.cardTitle}>Resume</div>
              </div>
            </div>
          </div>
          <div className={styles.cardBody}>
            <div className={`${styles.docRow} ${styles.docRowFirst}`}>
              <div className={styles.docIcon}>
                <IconFileTypePdf size={19} />
              </div>
              <div className={styles.docInfo}>
                <div className={styles.docName}>{data?.name}</div>
                <div className={styles.docMeta}>{data?.meta}</div>
              </div>
              <Button
                variant="outlineBlue"
                as="a"
                href={data?.pdfUrl}
                size="sm"
                className={styles.docBtn}
                leftIcon={<IconDownload size={14} />}
              >
                Download
              </Button>
            </div>
          </div>
        </div>
      </Reveal>

      <Reveal index={1} resetKey={resetKey}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardHeaderLeft}>
              <div className={styles.cardIcon}>
                <IconCertificate size={18} />
              </div>
              <div>
                <div className={styles.cardTitle}>Certificates</div>
              </div>
            </div>
          </div>
          <div className={styles.cardBody}>
            {data?.workHistoryExperience
              ?.filter((item) => item?.workCertificate)
              ?.map((item, index) => (
                <div
                  className={`${styles.docRow} ${index === 0 ? styles.docRowFirst : ""}`}
                  key={index}
                >
                  <div className={styles.docIcon}>
                    <IconFileTypePdf size={19} />
                  </div>
                  <div className={styles.docInfo}>
                    <div className={styles.docName}>
                      Certificate {index + 1}
                    </div>
                  </div>
                  <Button
                    variant="outlineBlue"
                    size="sm"
                    as="a"
                    href={item?.workCertificate}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.docBtn}
                    leftIcon={<IconDownload size={14} />}
                  >
                    Download
                  </Button>
                </div>
              ))}
          </div>
        </div>
      </Reveal>

      <Reveal index={2} resetKey={resetKey}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardHeaderLeft}>
              <div className={styles.cardIcon}>
                <IconVideo size={18} />
              </div>
              <div>
                <div className={styles.cardTitle}>Videos</div>
              </div>
            </div>
          </div>
          <div className={styles.cardBody}>
            <div className={`${styles.mediaRow} ${styles.mediaRowFirst}`}>
              <div className={styles.mediaThumb}>
                <IconPlayerPlay size={18} />
              </div>
              <div className={styles.docInfo}>
                <div className={styles.docName}>Uploaded Video</div>
                {/* <div className={styles.docMeta}>{vid.meta}</div> */}
              </div>
              <Button
                variant="outlineBlue"
                size="sm"
                as="a"
                href={data?.videoUrl}
                target="_blank"
                rel="noreferrer"
                className={styles.docBtn}
                leftIcon={<IconDownload size={14} />}
              >
                Download
              </Button>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  );
}
